import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { layoutAsyncConnect } from 'utils/asyncConnectWrapper';
import { isLoading, load } from 'modules/Football/reducers/vidiprinter';
import FootballVidiprinter from 'modules/Football/components/FootballVidiprinter';
import CaretLink from 'modules/Common/components/CaretLink';

const VIDIPRINTER_LINES = 5;
const REFRESH_INTERVAL_MILLIS = 10000;

@layoutAsyncConnect(
  "HomeFootballVidiprinter",
  [{
    dispatch: () => load(VIDIPRINTER_LINES),
    preventResolve: ({state}) => isLoading(state),
    refreshInterval: REFRESH_INTERVAL_MILLIS,
    state: state => {
      const {football: {vidiprinter = {items: []}}} = state;
      return {vidiprinter};
    }
  }]
)
export default class HomeFootballVidiprinter extends Component {
  static propTypes = {
    vidiprinter: PropTypes.object,
    dispatch: PropTypes.func.isRequired
  };

  render() {
    const {
      items: {
        lines = []
      } = {}
    } = this.props.vidiprinter;

    const limitedVidiprinterItems = {
      lines: lines.slice(0, VIDIPRINTER_LINES)
    };

    return (
      <div className="home-football-vidiprinter" id="football-vidiprinter">
        <div className="section-title">Vidiprinter</div>
        <FootballVidiprinter data={limitedVidiprinterItems}/>
        <div><CaretLink to="/football/live/vidiprinter">See Full Vidiprinter</CaretLink></div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/Home/containers/HomeFootballVidiprinter.js